// ...existing code...
import React, { useState } from "react";
import CalculateForm from "../../components/CalculateForm.tsx";
import CalculateForm2 from "../../components/CalculateForm2.tsx";

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

const TabPanel: React.FC<{ children?: React.ReactNode; index: number; value: number }> = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

// const CalculationLogicPage: React.FC = () => {
//   // 这里放“计算逻辑页面”的内容，简单占位示例，按需替换为真实逻辑或独立组件
//   return (
//     <div>
//       <h5 className="text-center">Calculation Logic</h5>
//       <p>在此处展示或调试计算逻辑、公式说明、示例计算或者历史计算记录。</p>
//       {/* 可添加更多 UI 或导入现有计算组件 */}
//     </div>
//   );
// };

const CalculatePage = () => {
  const [tab, setTab] = useState<number>(0);

  const handleChange = (_e: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <div style={{ textAlign: "left" }}>
      {/* <h3 style={{ margin: "0 auto", textAlign: "center" }}>Calculate the number of blends and cans</h3> */}

      <div
        style={{
          // marginTop: 40,
          // 与屏幕等高，内容超出时显示滚动条
          marginBottom: 20,
          maxWidth: "100%",
          height: "calc(100vh - 100px)",
          overflowY: "auto",
          // padding: 20,
          border: "1px solid #ccc",
          borderRadius: 8,
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          margin: "0px auto",
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tab} onChange={handleChange} centered>
            <Tab label="Calculate 1" />
            <Tab label="Calculate 2" />
          </Tabs>
        </Box>



        <TabPanel value={tab} index={0}>
          <CalculateForm2 />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <CalculateForm />
        </TabPanel>
      </div>
    </div>
  );
};

export default CalculatePage;
// ...existing code...